/* ==========================================================================
   CL · Mood Pack Carrusel — pestañas con animación
   Cambia el panel activo y re-dispara la animación de entrada (.is-anim,
   la "barajada" vive en el CSS). El panel activo usa display:contents,
   así que el reflow para reiniciar la animación se fuerza en el grid
   contenedor. En el editor, seleccionar un bloque activa su pestaña.
   ========================================================================== */

(function () {
	'use strict';

	function initMpc(root) {
		if (!root || root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var inner = root.querySelector('.cl-mpc__inner');
		var tabs = [].slice.call(root.querySelectorAll('[data-mpc-tab]'));
		var panels = [].slice.call(root.querySelectorAll('[data-mpc-panel]'));
		if (!tabs.length || !panels.length) return;

		function activate(id, animate) {
			tabs.forEach(function (tab) {
				var on = tab.getAttribute('data-mpc-tab') === id;
				tab.classList.toggle('is-active', on);
				tab.setAttribute('aria-selected', on ? 'true' : 'false');
			});
			panels.forEach(function (panel) {
				var on = panel.getAttribute('data-mpc-panel') === id;
				panel.classList.toggle('is-active', on);
				panel.classList.remove('is-anim');
				if (on) {
					var row = panel.querySelector('.cl-mpc__row');
					if (row) row.scrollLeft = 0;
					if (animate) {
						/* reflow en el contenedor (el panel es display:contents) */
						void inner.offsetWidth;
						panel.classList.add('is-anim');
					}
				}
			});
		}

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				if (tab.classList.contains('is-active')) return;
				activate(tab.getAttribute('data-mpc-tab'), true);
			});
		});

		/* estado inicial sin animación (sin parpadeo al cargar) */
		var first = root.querySelector('[data-mpc-tab].is-active') || tabs[0];
		activate(first.getAttribute('data-mpc-tab'), false);
	}

	function initAll() {
		document.querySelectorAll('[data-cl-mpc]').forEach(initMpc);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		var root = event.target.querySelector('[data-cl-mpc]');
		if (root) {
			root.dataset.clInit = '';
			initMpc(root);
		}
	});

	/* En el editor: al seleccionar un bloque se muestra su pestaña */
	document.addEventListener('shopify:block:select', function (event) {
		var root = event.target.closest ? event.target.closest('[data-cl-mpc]') : null;
		if (!root) root = event.target.querySelector ? event.target.querySelector('[data-cl-mpc]') : null;
		if (!root) return;
		var id = event.detail && event.detail.blockId;
		if (!id) return;
		var tab = root.querySelector('[data-mpc-tab="' + id + '"]');
		if (tab) tab.click();
	});
})();
